// extracted by mini-css-extract-plugin
export var button = "order-result-module--button--f6bc0";
export var container = "order-result-module--container--fa810";
export var contentBox = "order-result-module--content-box--54d85";
export var disclaimer = "order-result-module--disclaimer--30c39";
export var emotics = "order-result-module--emotics--06121";
export var infoIcon = "order-result-module--info-icon--2c5d2";
export var text = "order-result-module--text--4543d";
export var titleText = "order-result-module--title-text--eb7c1";